var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0833 9.49935L8.3125 11.0827V7.91602L11.0833 9.49935Z",
    fill: "#D0D0D0",
    stroke: "#D0D0D0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5835 10.0594V8.93924C1.5835 6.64736 1.5835 5.50103 2.29995 4.76399C3.0172 4.02616 4.14612 3.99449 6.40316 3.93036C7.47191 3.90028 8.56441 3.87891 9.50016 3.87891C10.4351 3.87891 11.5276 3.90028 12.5972 3.93036C14.8542 3.99449 15.9831 4.02616 16.6996 4.76399C17.4168 5.50103 17.4168 6.64816 17.4168 8.93924V10.0594C17.4168 12.3521 17.4168 13.4977 16.7004 14.2355C15.9831 14.9725 14.855 15.005 12.5972 15.0683C11.5284 15.0992 10.4359 15.1206 9.50016 15.1206C8.56521 15.1206 7.47271 15.0992 6.40316 15.0683C4.14612 15.005 3.0172 14.9733 2.29995 14.2355C1.5835 13.4977 1.5835 12.3513 1.5835 10.0602V10.0594Z",
    stroke: "#D0D0D0",
    strokeWidth: 1.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.2e09087b846f96fd312e3db5f06a92f9.svg";
export { ForwardRef as ReactComponent };